import { render, staticRenderFns } from "./AiPromptsList.vue?vue&type=template&id=241ca3d6&scoped=true&"
import script from "./AiPromptsList.vue?vue&type=script&lang=js&"
export * from "./AiPromptsList.vue?vue&type=script&lang=js&"
import style0 from "./AiPromptsList.vue?vue&type=style&index=0&id=241ca3d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241ca3d6",
  null
  
)

export default component.exports